import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, ButtonGroup } from 'react-bootstrap';
import AppContext from 'context/Context';
import {
  post,
  patch,
  getBoardMesuarables
} from 'services/bs-sector-measurable/measurableService';
import { inputPopulateType, valueCompareType } from 'data/TempData';
import OptionListSelect from 'components/dropdowns/OptionListSelect';
import FormulaEditor from 'components/common/FormulaEditor';
// import { isTargetUseDecimal } from 'helpers/kpiHelper';

const MeasurableModal = ({
  data,
  isShow,
  handleClose,
  handleSubmit
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  useEffect(() => {
    setFormData(data);
  }, [data]);
  useEffect(() => {
    if (!data?.kpiId) return;

    loadMeasurable(data.kpiId);
  }, [data?.kpiId]);

  const loadMeasurable = id => {
    if (!id) {
      setField([]);
      return;
    }

    getBoardMesuarables(id).then(res => {
      const data =
        res?.data?.map(x => ({
          id: x.id,
          name: x.name
        })) || [];

      setField(data);
    });
  };

  const [formData, setFormData] = useState(data);
  const [fields, setField] = useState([]);
  const handleChange = ({ target }) => {
    console.log(target);
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };
  const handleTargetType = target => {
    let value = target.value;
    setFormData({ ...formData, targetType: value });
  };
  const handleNumOfDecimal = e => {
    const { value } = e.target;
    console.log(e.target);
    if (Number(value) < 0) {
      return;
    }
    setFormData(prev => ({
      ...prev,
      numOfDecimal: Number(value)
    }));
  };

  const onSubmit = async e => {
    console.log('submit');
    e.preventDefault();

    const rq = { ...formData, formula };

    if (rq.id > 0) {
      await patch(rq.id, { ...rq });
    } else {
      if (!rq.compareType) {
        rq.compareType = valueCompareType[0].value;
      }
      await post({ ...rq });
    }
    handleSubmit();
  };

  const handleOptionChange = e => {
    setFormData({ ...formData, inputMethod: parseInt(e.target.value, 10) });
  };
  const handleCompareTypeChange = e => {
    setFormData({
      ...formData,
      compareType: parseInt(e.target.value, 10)
    });
  };

  const [formula, setFormula] = useState(formData.formula);
  console.log(formData);
  const saveFormula = (formulaWithNames, formulaWithIds) => {
    setFormula(JSON.stringify({ formulaWithNames, formulaWithIds }));
  };

  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {formData.id > 0 ? 'Edit' : 'Create'} Measurable
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3">
            <Form.Label className="fs-0">Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData?.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fs-0">Target Type</Form.Label>
            <OptionListSelect
              optionKey="balance.score.card.targettype"
              selected={
                formData && formData.targetType ? formData.targetType : 0
              }
              changeFn={opt => handleTargetType(opt)}
            />
          </Form.Group>
          {/* {isTargetUseDecimal(formData.targetType) ? ( */}
          <Form.Group className="mb-3">
            <Form.Label className="fs-0">Number of decimal</Form.Label>
            <Form.Control
              type="number"
              name="numOfDecimal"
              required
              value={formData?.numOfDecimal ?? 0}
              onChange={handleNumOfDecimal}
            />
          </Form.Group>
          {/* ) : (
            ''
          )} */}
          <Form.Group className="mb-3">
            <Form.Label className="fs-0">Value compare with Target</Form.Label>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'left',
                gap: '10px',
                padding: '10px'
              }}
            >
              <Form.Label className="fs-0">Percent</Form.Label>
              <Form.Control
                type="number"
                name="variationPercentage"
                required
                value={formData?.variationPercentage}
                onChange={handleChange}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'left',
                gap: '10px',
                padding: '10px'
              }}
            >
              <Form.Label style={{ paddingTop: '7px' }} className="fs-0">
                Green When :{' '}
              </Form.Label>
              {valueCompareType.map(option => (
                <ButtonGroup
                  key={option.value}
                  className="btn-group-navbar-style"
                  style={{
                    display: 'flex',
                    marginTop: '0px',
                    marginLeft: '10px',
                    alignItems: 'center'
                  }}
                >
                  <Form.Label
                    htmlFor={`option-${option.value}`}
                    className="cursor-pointer hover-overlay"
                    style={{
                      marginBottom: '0',
                      paddingRight: '5px'
                    }}
                  >
                    {option.label}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    id={`option-${option.value}`}
                    name="compareType"
                    value={option.value}
                    onChange={handleCompareTypeChange}
                    // checked={formData?.compareType === option.value}
                    checked={
                      formData?.compareType
                        ? formData.compareType === option.value
                        : option.value === valueCompareType[0].value
                    }
                    style={{
                      margin: '0'
                    }}
                  />
                </ButtonGroup>
              ))}
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fs-0">Value Input Type</Form.Label>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'left',
                gap: '10px',
                padding: '10px'
              }}
            >
              {inputPopulateType.map(option => (
                <ButtonGroup
                  key={option.value}
                  className="btn-group-navbar-style"
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Form.Label
                    htmlFor={`option-${option.value}`}
                    className="cursor-pointer hover-overlay"
                    style={{
                      marginBottom: '0',
                      paddingRight: '5px'
                    }}
                  >
                    {option.label}
                  </Form.Label>
                  <Form.Check
                    type="radio"
                    id={`option-${option.value}`}
                    name="dataPopulate"
                    value={option.value}
                    onChange={handleOptionChange}
                    // checked={formData?.inputMethod === option.value}
                    checked={
                      formData?.inputMethod
                        ? formData.inputMethod === option.value
                        : option.value === inputPopulateType[0].value
                    }
                    style={{
                      margin: '0'
                    }}
                  />
                </ButtonGroup>
              ))}
            </div>

            {formData.inputMethod === 3 && (
              <FormulaEditor
                formulaString={
                  formula ? JSON.parse(formula)?.formulaWithIds : null
                }
                fields={fields?.filter(x => x.id != formData.id)}
                saveFormula={saveFormula}
              />
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

MeasurableModal.propTypes = {
  measurables: PropTypes.array,
  data: PropTypes.object,
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default MeasurableModal;
